import React, { createContext, useState } from "react";

export const SingleCategoryPageContextStart = createContext();

export default function SingleCategoryPageContext(props) {
  const [categoryDetail, setCategoryDetail] = useState({});

  return (
    <SingleCategoryPageContextStart.Provider
      value={{ categoryDetail, setCategoryDetail }}
    >
      {props.children}
    </SingleCategoryPageContextStart.Provider>
  );
}
